import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchDocumentsType, createDocumentType, updateDocumentType, deleteDocumentType } from "../api/administrationService";

export const useDocumentsType = () => {
  const queryClient = useQueryClient();

  // ✅ Consulta optimizada para obtener los tipos de documentos
  const {
    data: documentsType = [], // Previene `undefined` al hacer `.map()`
    error,
    isLoading,
  } = useQuery({
    queryKey: ["documentsType"],
    queryFn: fetchDocumentsType,
    staleTime: 1000 * 60 * 5, // Cachea los datos por 5 minutos
    refetchOnWindowFocus: false, // Evita re-fetch cuando se cambia de ventana
    refetchOnMount: false, // No re-fetch al montar el componente si ya está en caché
    refetchOnReconnect: false, // Evita re-fetch al reconectar a la red
  });

  // ✅ Roles reutilizable para invalidar la caché después de cada mutación
  const invalidateDocumentsTypeCache = () => {
    queryClient.invalidateQueries({ queryKey: ["documentsType"] });
  };

  // ✅ Mutación para crear un tipo de documento
  const createMutation = useMutation({
    mutationFn: createDocumentType,
    onSuccess: invalidateDocumentsTypeCache,
  });

  // ✅ Mutación para actualizar un tipo de documento
  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateDocumentType(id, data),
    onSuccess: invalidateDocumentsTypeCache,
  });

  // ✅ Mutación para eliminar un tipo de documento
  const deleteMutation = useMutation({
    mutationFn: deleteDocumentType,
    onSuccess: invalidateDocumentsTypeCache,
  });

  return {
    documentsType, // Siempre un array seguro
    error,
    isLoading,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
